import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Lead, LeadPartner } from '../../interfaces/Lead.model';
// import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LeadService {



  subject$: ReplaySubject<LeadPartner[]> = new ReplaySubject<LeadPartner[]>(1);
  data$: Observable<LeadPartner[]> = this.subject$.asObservable();

  subjectLead$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  lead$: Observable<any> = this.subjectLead$.asObservable();

  leadTags$: BehaviorSubject<Lead> = new BehaviorSubject<any>(null);
  leadTags: Observable<Lead> = this.leadTags$.asObservable();

  constructor(private http: HttpClient) { }

  getLeads(filterCriteria,pageNo,pageSize): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/leadPartner?pageNo=${pageNo}&pageSize=${pageSize}`, filterCriteria, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }
  getServiceLeads(filterCriteria): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/service/leadPartner`, filterCriteria, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  getRawLeads(storeId, filter,pageNo,pageSize): Promise<any> {

    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/raw?pageNo=${pageNo}&pageSize=${pageSize}`, filter, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }


  changeLeadStatus(toStatusId: string, leadPartner: LeadPartner, answer,isEnabled: any, isTransferToServiceIsp: boolean): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.put(environment.baseURL + `/admin/lead/move/leadPartner/status/${toStatusId}`, { leadPartnerMapping: leadPartner, data: answer, isVoucherEnabled:isEnabled, transferToServiceIsp: isTransferToServiceIsp},
      {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }).toPromise().then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  getLeadById(leadId): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/lead/lpm/${leadId}`,
      {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }).toPromise().then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  getSchedules(): Promise<any> {

    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/lead/schedule`, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  modifyLead(lead): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.put(environment.baseURL + `/admin/lead/modify/leadPartner`, lead,
      {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }).toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  getExportsLeads(filterCriteria): Promise<any> {

    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/export`, filterCriteria, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }
  getExportsLeadsForVfn(filterCriteria): Promise<any> {

    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/export/raw`, filterCriteria, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  getTags(): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/setting/tag/lead`, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }


  checkMobileNo(mobileNo: string) {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/lead/duplicateCheck/${mobileNo}`, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });

  }


  updateLeadTag(leadPartner: any): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/tag/update`,
    leadPartner,
      {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }).toPromise()
      .then<any>((result: any) => {
        //debugger;
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });;
  }

  getProductCategories(): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/setting/product/category`, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  buildLeadStatus(lead, leadStatuses) {
    if (lead.status) {
      lead.leadStatus = this.getLeadStatusTagByStatus(lead.status, leadStatuses);
    }
       if (lead.snapshot && lead.snapshot.length > 0) {
       let leadSnapshot =  lead.snapshot;
       let snapshots =  Math.max.apply(Math, leadSnapshot.map(function(o) { return o.id; }));
       let snap = leadSnapshot.filter(snap => snap.id == snapshots)
      lead.snapshotLastInteraction = snap[0].movedOn;
      lead.snapshotLastRemark =JSON.parse(snap[0].dataCaptured).note;

    }
  }

  buildProductsEnquired(lead: any, productCategories: any) {
    if (lead.productEnquired && productCategories && productCategories.length > 0) {
      const prodIds = lead.productEnquired.split(',');
      let prods = [];
      for (let id of prodIds) {
        const pr = productCategories.filter(a => a.id === Number(id))[0];
        if (pr) {
          prods.push(pr.name);
        }

      }
      lead.productsEnquired = prods.join(',');
    }
  }

  buildExtraInfo(lead: any) {
    if (lead.extraInfo && lead.extraInfo !== "{}") {
      if (lead.sourceDisplayName == "Store Locator Home - Request Callback" || lead.sourceDisplayName == "Partner Page - Request Callback") {
        const parsedInfo = JSON.parse(lead.extraInfo);
        const datevalue = parsedInfo["callDate"];
        const timevalue = parsedInfo["callTime"];
        const prodvalue = parsedInfo["productofIntersted"];
        const date = new Date(datevalue);
        const formattedDate = this.formatDate(date);
        lead.callbackdate = formattedDate;
        lead.callbacktime = timevalue;
        // lead.callbackproductInterested = prodvalue;
      } else {
        const parsedInfo = JSON.parse(lead.extraInfo);
        const value = parsedInfo["when_are_you_planning_to_make_the_purchase?"];
        lead.purchasePlan = value;
      }
    }
  }
//   buildExtraInfoService(lead: any) {
//     debugger
//       if (lead.leadLeadStatusId == 29) {
//         const parsedInfo = JSON.parse(lead.extraInfo);
//         const datevalue = parsedInfo[lead.callDate];
//         const timevalue = parsedInfo[lead.callTime];
//         const date = new Date(datevalue);
//         const formattedDate = this.formatDate(date);
//         lead.callbackdate = formattedDate;
//         lead.callbacktime = timevalue;
//       } else {
//         const parsedInfo = JSON.parse(lead.extraInfo);
//         const value = parsedInfo["when_are_you_planning_to_make_the_purchase?"];
//         lead.purchasePlan = value;
//       }
//   }

  getLeadStatusTagByStatus(status: any, leadStatuses): any {
    return [leadStatuses.get(status.id)]
  }

  prepareDataOne(lead: any, leadStatuses : any,productCategories : any, leadStatusesArray : any): any {
    this.buildSourcesAndStatuseOne(lead, leadStatuses, leadStatusesArray);

        this.buildLeadStatus(lead,leadStatuses);
        this.buildProductsEnquired(lead, productCategories);

    return lead;
}

prepareData(leads: any[],  leadStatuses : any,productCategories : any, leadStatusesArray : any): any[] {
  this.buildSourcesAndStatuses(leads, leadStatuses, leadStatusesArray);

  for (let lead of leads) {
      this.buildLeadStatus(lead, leadStatuses);
      this.buildProductsEnquired(lead, productCategories);
  }
  return leads;
}

private buildSourcesAndStatuses(leads: any, leadStatuses:any, leadStatusesArray : any) {
  leads.forEach(ele => {
      if (ele.source) {
          // this.sources1.set(ele.source.id, ele.source.name);
      }
      if (ele.status) {
          // this.statues1.set(ele.status.id, ele.status.displayName);
          leadStatuses.set(ele.status.id, this.getLeadStatusTag(ele.status))
      }
  });

  leadStatusesArray = Array.from(leadStatuses, ([key, value]) => {
      return { id: key, name: value };
  });

}


private buildSourcesAndStatuseOne(lead: any, leadStatuses: any, leadStatusesArray : any) {
    if (lead.status) {
        leadStatuses.set(lead.status.id, this.getLeadStatusTag(lead.status))
    }
    leadStatusesArray = Array.from(leadStatuses, ([key, value]) => {
    return { id: key, name: value };
    });
}

getLeadStatusTag(status: any): any {
  return {
      id: status.id,
      text: status.displayName,
      textClass: "text-green",
      bgClass: "bg-green-light",
      previewClass: "bg-green",
  }
}

getDashboardLeads() : Promise<any>{
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/lead/dashboard`,
    {
      headers: new HttpHeaders({
        "Authorization": token
      })
    }).toPromise().then<any>( (result : any) =>{
      return Promise.resolve(result);
    }).catch( err =>{
      return Promise.reject(null);
    })
}

getDashboardServiceLeads() : Promise<any>{
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/lead/service/dashboard`,
    {
      headers: new HttpHeaders({
        "Authorization": token
      })
    }).toPromise().then<any>( (result : any) =>{
      return Promise.resolve(result);
    }).catch( err =>{
      return Promise.reject(null);
    })
}


  getAllFilters(): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/setting/filters`, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }


  leadStoreTransferPreFlight(filterCriteria): Promise<any> {

    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/transfer/preflight`, filterCriteria, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }
  leadTransferSummaryList(filterCriteria): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/transfer/preflight/summary`, filterCriteria, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }


  leadTransferStore(leadPartners, toStore): Promise<any> {

    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.put(environment.baseURL + `/admin/lead/transfer/${toStore}`, leadPartners, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  allocateLeads(payload, toStore): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/transfer/bulk/${toStore}`, payload, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }


  groupByLeadStatus(leadPartners, getLead) {
    const map = new Map();
    leadPartners.forEach((leadPartner) => {
         const key = getLead(leadPartner);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [leadPartner]);
         } else {
             collection.push(leadPartner);
         }
    });
    return map;
}

  getGoogleReviews(req: any){
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/reviews`, req, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    }) .toPromise()
    .then<any>((result: any) => {
      return Promise.resolve(result);
    })
    .catch((err) => {
      return Promise.reject(null);
    });

  }

  getGoogleReviewExports(req: any){
    let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(environment.baseURL + `/admin/reviewExportsData`, req, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    }) .toPromise()
    .then<any>((result: any) => {
      return Promise.resolve(result);
    })
    .catch((err) => {
      return Promise.reject(null);
    });

  }

  sendReplyforReview(id, value) : Promise<any>{
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/review-reply`,{id:id ,message :value}, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    }) .toPromise()
    .then<any>((result: any) => {
      return Promise.resolve(result);
    })
    .catch((err) => {
      return Promise.reject(null);
    });

  }

  serialnumbercheck(serialno): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/lead/duplicate/check/${serialno}`, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  getMetabaseToken(dashboardId:any): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/analytics/token?d=`+dashboardId, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }


  getReportMaster(): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.get(environment.baseURL + `/admin/lead/get/report/master`, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }

  generateReport(filter :any , reportId :any) :  Promise<any>{
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/report/all/report/?reportId=${reportId}`,

      filter
    ,
    {
      headers: new HttpHeaders({
      "Authorization": token
      })
    })
    .toPromise()
    .then<any>((result: any) => {
      return Promise.resolve(result);
    })
    .catch((err) => {
      return Promise.reject(null);
    });
  }

  getAllReports(pageNo:any, pageSize:any, filters): Promise<any>{
    let token=JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL+`/admin/lead/get/all/reports/?pageNo=${pageNo}&pageSize=${pageSize}`,
    filters,
    {
      headers: new HttpHeaders({
      "Authorization": token
      })
    }
    )
    .toPromise()
    .then<any>((result: any) => {
      return Promise.resolve(result);
    })
    .catch((err) => {
      return Promise.reject(null);
    });
  }

  downLoadReport(reportId :string): Promise<any>{
    let token=JSON.parse(localStorage.getItem('user'))?.token;

    return this.http.get(environment.baseURL+`/admin/lead/download/report/${reportId}`,
    {
      observe:'response',
      headers: new HttpHeaders({
      "Authorization": token
      }),
      responseType:'arraybuffer'
    },
    )
    .toPromise()
    .then<any>((result: any) => {
      return Promise.resolve(result);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
  }

  getWalkinList(filterCriteria,pageNo,pageSize): Promise<any> {
    filterCriteria.pageNo = pageNo;
    filterCriteria.pageSize = pageSize;
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(`${environment.baseURL}/admin/lead/walkin`, filterCriteria, {
      headers: new HttpHeaders({
        "Authorization": token
      })
    })
      .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
    }

    getWalkinListExport(filterCriteria): Promise<any> {

      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(environment.baseURL + `/admin/lead/walkin/export`, filterCriteria, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    fileUpload(formData): Promise<any>{
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(`${environment.baseURL}/admin/lead/walkin/import`, formData, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    getRuleForLeads(searchBy:string,start:any,end:any){
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/rule/getallrules/${searchBy}/${start}/${end}`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }) .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });

    }

    saveRuleForLeads(leadForward): Promise<any> {

      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(environment.baseURL + `/admin/lead/rule/saveRules`, leadForward, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    updateStatusForRule(req: any){
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(environment.baseURL + `/admin/lead/rule/updateStatus`, req, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }) .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });

    }

    getAllSourceForRule(): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/rule/getallsources`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    getAllCampaignForRule(): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/rule/campaign/getAllCampagins`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    getCampaignForSource(sourceId:any){
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/rule/campaign/getcampaignbysource?sourceId=${sourceId}`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }) .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });

    }

    getAllStoresForRule(): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/rule/getAllPartners`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    toggleStatusForRule(id:any,status:any){
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.put(environment.baseURL + `/admin/lead/rule/updatestatus/${status}/${id}`,null,{
        headers: new HttpHeaders({
          "Authorization": token
        })
      }) .toPromise()
      .then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });

    }

    getRulesExport(filterCriteria:any,pageNo:any,pageSize:any): Promise<any> {
      filterCriteria.pageNo = pageNo;
      filterCriteria.pageSize = pageSize;
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(environment.baseURL + `/admin/lead/rule/export`, filterCriteria, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    getLpmStatus(status: any) : Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/lpm/status/${status}`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    formatDate(date: Date): string {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
    }
    getCategories(): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/getCategory`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }
    getPriceConfig(): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/pricefield-config`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }
    getFilteredProducts(category:any): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/getProductsBasedOnCategory/${category}`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }
    getServiceTag(product:String): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/getServiceNo/${product}`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }
    updateServiceTagStatus(sNo:String): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(environment.baseURL + `/admin/lead/serviceTag/${sNo}`,{}, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    tagsfileUpload(formData): Promise<any>{
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(`${environment.baseURL}/admin/lead/service-tag/import`, formData, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    getServcieTagList(filterCriteria,pageNo,pageSize): Promise<any> {
      filterCriteria.pageNo = pageNo;
      filterCriteria.pageSize = pageSize;
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.post(`${environment.baseURL}/admin/lead/service-tag`, filterCriteria, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
      }

      getServiceTagExport(filterCriteria): Promise<any> {

        let token = JSON.parse(localStorage.getItem('user'))?.token;
        return this.http.post(environment.baseURL + `/admin/lead/service-tag/export`, filterCriteria, {
          headers: new HttpHeaders({
            "Authorization": token
          })
        })
          .toPromise()
          .then<any>((result: any) => {
            return Promise.resolve(result);
          })
          .catch((err) => {
            return Promise.reject(null);
          });
      }

      getMakeCallConfig(): Promise<any> {
        let token = JSON.parse(localStorage.getItem('user'))?.token;
        return this.http.get(environment.baseURL + `/admin/lead/makeacall-config`, {
          headers: new HttpHeaders({
            "Authorization": token
          })
        })
          .toPromise()
          .then<any>((result: any) => {
            return Promise.resolve(result);
          })
          .catch((err) => {
            return Promise.reject(null);
          });
      }

    makeCall(lpmId:any): Promise<any> {
        let token = JSON.parse(localStorage.getItem('user'))?.token;
        return this.http.post(environment.baseURL + `/admin/lead/makeacall?lpmId=${lpmId}`,null, {
          headers: new HttpHeaders({
            "Authorization": token
          })
        })
          .toPromise()
          .then<any>((result: any) => {
            return Promise.resolve(result);
          })
          .catch((err) => {
            return Promise.reject(null);
          });
    }

    getIsVoucherEnable(lpmId:any): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/campaign/voucher/enabled/${lpmId}`, {
        headers: new HttpHeaders({
          "Authorization": token
        })
      })
        .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    getVchConfig(): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/campaign/masters/vch_code_config`,
        {
          headers: new HttpHeaders({
            "Authorization": token
          })
        }).toPromise().then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }

    validatePincode(pincode: string): Promise<any> {
        let token = JSON.parse(localStorage.getItem('user'))?.token;
        return this.http.get(environment.baseURL + `/admin/lead/service/pincode?pincode=${pincode}`, {
          headers: new HttpHeaders({
            "Authorization": token
          })
        }).toPromise()
        .then((result: any) => Promise.resolve(result))
        .catch(() => Promise.reject(null));
    }

    getStatusToRemove(storeId:any): Promise<any> {
      let token = JSON.parse(localStorage.getItem('user'))?.token;
      return this.http.get(environment.baseURL + `/admin/lead/service/statusConfig?storeID=${storeId}`,
        {
          headers: new HttpHeaders({
            "Authorization": token
          })
        }).toPromise().then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });
    }


  serviceCenterNameStore(payload: any): Promise<any> {
    let token = JSON.parse(localStorage.getItem('user'))?.token;
    return this.http.post(environment.baseURL + `/admin/lead/service/service-transfer`, payload ,
      {
        headers: new HttpHeaders({
          "Authorization": token
        })
      }).toPromise().then<any>((result: any) => {
        return Promise.resolve(result);
      })
      .catch((err) => {
        return Promise.reject(null);
      });
  }


}

